<template>
  <div class="display-box" >
    <div
      class="module-items"
    >
      <p class="w100 font-28 tx-c">主题分类</p>
      <draggable
        @update="sortTab"
        :value="subjectData.data"
        animation="300"
        class="tab-draggable"
      >
        <div class="tab-item" v-for="(e, i) in subjectData.data" :key="i" @click="tabClick(e, i)">
          {{e.subName}}
          <img :src="`${baseUrl}images/tab-down.png`" alt="" v-show="subjectData.data[activeIndex].subId==e.subId">
        </div>
      </draggable>
      <template v-if="subjectData.data">
        <draggable
          @update="sortModuleItem"
          :value="subjectData.data[activeIndex].serveList"
          animation="300"
          class="module-draggable"
        >
          <div class="serve-item" v-for="(e, i) in subjectData.data[activeIndex].serveList" :key="i" >
            <div class="serve-logo">
              <img :src="e.serveLogo" alt="">
            </div>
            <div class="serve-name ellipsis">{{e.serveName}}</div>
          </div>
        </draggable>
      </template>
      <!-- <div class="serve-item" >
        <div class="serve-logo">
          <img :src="`${baseUrl}images/more.png`" alt="">
        </div>
        <div class="serve-name ellipsis">更多</div>
      </div> -->
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "subject",
  components: { draggable },
  props: ['childModules'],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      subjectData: {},
      activeIndex: 0,
      span: 1,
      col: 4,
      changed: false,
    };
  },
  created(){
    let subject = this.moduleList.find((item) => {
      return item.cardType === 'SUBJECT'
    })
    if(subject){
      this.subjectData = JSON.parse(JSON.stringify(subject.cardModules[0]));
    }else {
      this.subjectData = this.childModules;
    }
  },
  computed: {
    ...mapGetters(['moduleList']),
  },
  methods: {
    handleWidth(col){
      switch (col) {
        case 1:
          return '100%'
        case 2:
          return '50%'
        case 3:
          return '33.3%'
        case 4:
          return '25%'
        case 5:
          return '20%'
        case 6:
          return '16.6%'
        default:
          return '50%'
      }
    },
    tabClick(item, index){
      // this.subjectData.activeTab = item;
      this.activeIndex = index;
      this.$forceUpdate()
    },
    sortModuleItem(e){
      let newIndex = e.newIndex;
      let oldIndex = e.oldIndex;

      let moduleItem = this.subjectData.data[this.activeIndex].serveList[oldIndex];
      this.subjectData.data[this.activeIndex].serveList.splice(oldIndex, 1);
      this.subjectData.data[this.activeIndex].serveList.splice(newIndex, 0, moduleItem);
      this.changed = true;
    },
    sortTab(e){
      let newIndex = e.newIndex;
      let oldIndex = e.oldIndex;

      let tabItem = this.subjectData.data[oldIndex];
      this.subjectData.data.splice(oldIndex, 1);
      this.subjectData.data.splice(newIndex, 0, tabItem);
      // 手动判断排序方式修改activeIndex
      if(oldIndex==this.activeIndex){
        this.activeIndex = newIndex
      }else if(oldIndex > this.activeIndex && newIndex <= this.activeIndex){
        this.activeIndex += 1;
      }else if(oldIndex < this.activeIndex && newIndex >= this.activeIndex){
        this.activeIndex -= 1;
      }
      this.changed = true;
    },
    changeComplete(){
      this.changed = false;
    },
  },
  watch: {},
  filters: {}
}
</script>

<style lang="less">
.module-items {
  padding: 10px 15px 0;
  background-color: #fff;
  .tab-draggable {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  .module-item {
    height: 100%;
    background-color: #F2F3F6;
    position: relative;
    cursor: move;
    >i {
      position: absolute;
      top: 10px;
      right: 10px;
      color: #1764A5;
      font-size: 23px;
      cursor: pointer;
    }
    &:hover {
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }
  }
  .tab-item {
    width: 128px;
    text-align: center;
    font-size: 18px;
    line-height: 38px;
    position: relative;
    cursor: pointer;
    img {
      position: absolute;
      bottom: -7px;
      left: 50%;
      margin-left: -45px;
    }
  }
  // .serve-box {
  //   background-color: #F5F6F8;
  //   padding: 14px 50px 0;
  //   flex-wrap: wrap;
    .serve-item {
      width: 25%;
      margin: 14px 0;
      cursor: move;
      user-select: none;
      .serve-logo {
        text-align: center;
        img {
          height: 60px;
          width: 60px;
        }
      }
      .serve-name {
        text-align: center;
        font-size: 18px;
        line-height: 46px;
      }
    }
  // }
}

</style>